import React from 'react';
import {
  Form, FormGroup, Label, Input, ButtonGroup, Button,
} from 'reactstrap';
import { useForm } from 'react-hook-form';
import * as _ from 'lodash';
import { useMutation } from 'react-apollo';
import { useToasts } from 'react-toast-notifications';
import { CREATE_PASSWORD, LOADER_MUTATION } from '../../../graphql-client/mutations';
import InputError from '../elments/InputError';
import {
  history,
  LOGO_LARGE_BLACK, handleGraphqlError, routeConstants, staticConstants, NUMERIC_VALUE, OFFER_TABS,
} from '../../../utils';

function CreatePasswordForm() {
  const {
    register, handleSubmit, errors, watch,
  } = useForm({ mode: 'onblur' });

  const inviteOfferId = history.location?.state?.inviteOfferId;
  const userId = history.location?.state?.userId;

  const { addToast } = useToasts();

  /* ---- create password mutation ----*/
  const [loader] = useMutation(LOADER_MUTATION, {
    variables: { show: false },
  });
  const [changePassword] = useMutation(CREATE_PASSWORD, {
    variables: {},

    onError(error) {
      loader({ variables: { show: false } });
      addToast(handleGraphqlError(error), { appearance: 'error' });
    },

    onCompleted(data) {
      loader({ variables: { show: false } });
      addToast(data.createPassword.message, { appearance: 'success' });
      if (inviteOfferId) {
        history.push(`${routeConstants.DASHBOARD}/${userId}/${inviteOfferId}/#${OFFER_TABS.PRIVATE_OFFERS}`);
      } else {
        history.push(routeConstants.DASHBOARD);
      }
    },
  });
  /* ---- end create password mutation ----*/

  const onSubmit = (data) => {
    loader({ variables: { show: true } });
    changePassword({ variables: _.pick(data, ['password']) });
  };

  return (
    <>
      <div className="forgot-password-wrapper">
        <div className="form-container">
          {/* <span className="icon icon-settings create-password-setting" /> */}
          <div className="forgot-password-logo">
            <img src={LOGO_LARGE_BLACK} alt="BYGmusic" />
          </div>
          <h2>Create password</h2>
          <p>
            Please create a secured password for your account.
          </p>
          <Form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <FormGroup className={errors.password ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
              <input type="hidden" value="prayer" />
              <Label
                for="password"
              >
                Password (Min 8 characters)
              </Label>
              <Input
                type="password"
                name="password"
                placeholder="Enter password"
                innerRef={register({
                  required: true,
                  maxLength: NUMERIC_VALUE.TWENTY,
                  minLength: NUMERIC_VALUE.EIGHT,
                })}
              />
              <InputError error={errors.password} max={NUMERIC_VALUE.TWENTY} min={NUMERIC_VALUE.EIGHT} />
            </FormGroup>
            <FormGroup className={errors.confirmpassword ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
              <Label
                for="confirmpassword"
              >
                Confirm password
              </Label>
              <Input
                type="password"
                name="confirmpassword"
                placeholder="Enter confirm password"
                innerRef={register(
                  {
                    required: true,
                    validate: {
                      confirmPassword: (value) => value === watch('password'),
                    },
                  },
                )}
              />
              <InputError error={errors.confirmpassword} max={NUMERIC_VALUE.TWENTY} min={NUMERIC_VALUE.EIGHT} />
            </FormGroup>
            <ButtonGroup className="justify-content-center">
              <Button
                color="primary"
                element="inlineBlock"
                type="submit"
                className="btn-md"
              >
                Save password
              </Button>
            </ButtonGroup>
          </Form>
        </div>
      </div>
    </>
  );
}

export default CreatePasswordForm;
